export class ArrayUtil {

  static join<T>(array: T[], separator: T): T[] {
    const joined: T[] = [];
    let index = 0;
    array.forEach((value, index) => {
      if (index > 0) {
        joined.push(separator);
      }
      joined.push(value);
    });
    return joined;
  }

  static toSorted<T>(array: T[], compareFn: (a: T, b: T) => number): T[] {
    if (!array) {
      return array;
    }
    const sorted: T[] = [...array];
    sorted.sort(compareFn);
    return sorted;
  }
}